<template>
    <div class="flex w-full overflow-hidden m-0 p-0">
        <div class="grid grid-nogutter w-full h-full gap-0 overflow-hidden">
            <div v-if="isAuth" class="col-12 xl:col-2 lg:col-3 md:col-4">
                <LeftHeader />
            </div>
            <div class="col-12 xl:col-10 lg:col-9 md:col-8">
                <div class="flex w-full p-0 m-0">
                    <TopHeader />
                </div>
                <div class="flex w-full p-0 m-0">
                    <!--Content start --> 
                    <router-view />
                    <Toast />
                    <!--Content end -->
                </div>
            </div>
        </div>
    </div>
    <ConfirmDialog class="border-none"/>
    <!-- Calc screen size -->
    <div v-if="!screen_size" class="hidden">{{ screen_size }}</div>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import LeftHeader from '@/components/public/left_header.vue'
import TopHeader from '@/components/public/top_header.vue'
import { useRoute } from 'vue-router'
import { useCookies } from "vue3-cookies"
import { mapActions } from "vuex"

export default {
    name: 'App',
    data() {
        return {
            local: (this.$store.getters.StateLang) ? this.$store.getters.StateLang : (this.$i18n.locale) ? this.$i18n.locale : 'ru',
            window: {
                width: 0,
                height: 0
            },
            route: useRoute(),
            cookies: useCookies(),
            isWebAppTg: false,
            initData: null,
            initDataUnsafe: null,
            loadAuth: false,
            vue_mode: null,
        }
    },
    components: {
        LeftHeader,
        TopHeader
    },
    watch: {
        initData: async function (val) {
            if(!val) return
            this.isWebAppTg = (val) ? true : false

            if(val) {
                try{
                    await this.$store.dispatch('setTgApp', true).then(() => {})
                } catch {}
            }
        }
    },
    computed: {
        isWebAppTg() {
            return (this.initData) ? true : false
        },
        screen_size() {
            const size = this.helper.screen_size(this)
            this.ActionScreenSize(size)
            return size
        },
        isAuth: function () { return this.$store.getters.isAuthenticated },
        userName() {
            return this.$store.getters.StateUserName
        },
        userAuth() {
            return this.$store.getters.StateUserAuth
        },
        userEmail() {
            return this.$store.getters.StateUserEmail
        }
    },
    methods: {
        ...mapActions(['ActionFetchUserData', 'ActionScreenSize', 'ActionFetchUserWallets', 'ActionGetRate']),
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            const size = this.helper.screen_size(this)
            this.ActionScreenSize(size)
        },
    },

    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    async mounted() {
        try{ this.ActionGetRate() } catch {}
        this.vue_mode = (process.env.VUE_APP_MODE == 'production') ? 'production' : 'development'
        if(this.isAuth) {
            try{ this.ActionFetchUserData() } catch {}
            try{ this.ActionFetchUserWallets() } catch {}  
        }
    },
}
</script>